import '@tensorflow/tfjs-core'
import '@tensorflow/tfjs-backend-webgl'

// Uncomment the line below if you want to use MediaPipe runtime.
import * as bodySegmentation from '@tensorflow-models/body-segmentation'
import { computed, MaybeRefOrGetter, shallowRef, toValue } from 'vue'

const SEGMENTATION_SETTINGS = {
  foregroundColor: { r: 255, g: 255, b: 255, a: 255 },
  backgroundColor: { r: 0, g: 0, b: 0, a: 255 },
  opacity: 1,
  flipHorizontal: false,
  foregroundThreshold: 1.0,
  drawContour: false,
  maskBlurAmount: 2.6
}

const MODEL = bodySegmentation.SupportedModels.MediaPipeSelfieSegmentation // or 'MediaPipe' need to uncomment up

const SEGMENTER_CONFIG = {
  runtime: 'mediapipe',
  solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation@0.1.1675465747',
  modelType: 'general'
}

export const useBodySegmentation = (_canvas: MaybeRefOrGetter<HTMLCanvasElement>, _canvasMask: MaybeRefOrGetter<HTMLCanvasElement>) => {
  const canvas = computed(() => toValue(_canvas))
  const canvasMask = computed(() => toValue(_canvasMask))
  const context = computed(() => canvas.value.getContext('2d', { willReadFrequently: true }))

  const segmenter = shallowRef<bodySegmentation.BodySegmenter>(null)

  const createSegmenter = async () => (segmenter.value = await bodySegmentation.createSegmenter(MODEL, SEGMENTER_CONFIG as bodySegmentation.MediaPipeSelfieSegmentationMediaPipeModelConfig))

  const createSegmentation = async (_content: MaybeRefOrGetter<HTMLImageElement | HTMLVideoElement>, _config: object) => {
    if (!_content || !context.value || !canvas.value || !canvasMask.value || !segmenter.value) return
    const { opacity, maskBlurAmount, flipHorizontal, foregroundColor, backgroundColor, foregroundThreshold, drawContour } = SEGMENTATION_SETTINGS
    const content = toValue(_content)
    const segmentation = await segmenter.value.segmentPeople(content, {
      flipHorizontal: false,
      multiSegmentation: false,
      segmentBodyParts: false,
      internalResolution: 0.1
    })

    const backgroundDarkeningMask = await bodySegmentation.toBinaryMask(
      segmentation,
      foregroundColor,
      backgroundColor,
      // @ts-expect-error
      _config ? _config.drawContour : drawContour,
      // @ts-expect-error
      _config ? _config.foregroundThreshold : foregroundThreshold
    )

    // @ts-expect-error
    await bodySegmentation.drawMask(canvasMask.value, content, backgroundDarkeningMask, opacity, _config ? _config.maskBlurAmount : maskBlurAmount, flipHorizontal)
    context.value.drawImage(content, 0, 0, canvas.value.width, canvas.value.height)
  }
  return {
    createSegmenter,
    createSegmentation,
    segmenter
  }
}
